import { FactoringRequest, FactoringStatus } from 'modules/domain/company/types'
import { Icons } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { apiClient } from 'modules/utils/httpClient'
import { AButton } from 'views/components/Analytics'
import { useAProgress } from 'hooks/useAProgress'
import { useTranslation } from 'react-i18next'
import { endpoints } from 'modules/endpoints'
import { ButtonsWrapper } from '../styled'

interface Props {
  factoringRequest: FactoringRequest
  refetchCompany: refetchFunc
}

export const ChangeFactoringStatus = ({ factoringRequest, refetchCompany }: Props) => {
  const { t } = useTranslation('company')
  const [changeStatusProgress, changeStatus] = useAProgress(
    (new_status) =>
      apiClient.post<{ new_status: string }>(
        endpoints.changeFactoringStatus(factoringRequest.company_id, factoringRequest.id),
        { new_status },
      ),
    {
      eventName: 'changeFactoringStatus',
      analyticsPayload: {
        id: factoringRequest.company_id,
      },
      onSuccess: () => refetchCompany(true),
    },
  )

  if (factoringRequest.status !== FactoringStatus.in_progress) {
    return null
  }

  return (
    <ButtonsWrapper>
      <AButton
        color="secondary"
        size="small"
        id="submit|acceptFactoring"
        Icon={Icons.IconCheck}
        onClick={() => changeStatus(FactoringStatus.accepted)}
        progress={changeStatusProgress}
      >
        {t('accept')}
      </AButton>

      <AButton
        color="destruct"
        size="small"
        id="submit|cancelFactoring"
        Icon={Icons.IconClear}
        onClick={() => changeStatus(FactoringStatus.cancelled)}
        progress={changeStatusProgress}
      >
        {t('cancel')}
      </AButton>
    </ButtonsWrapper>
  )
}
